import { render, staticRenderFns } from "./fornecedor.vue?vue&type=template&id=2444661e&"
import script from "./fornecedor.vue?vue&type=script&lang=js&"
export * from "./fornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports